"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardVersionSetting = void 0;
var CardVersionSetting;
(function (CardVersionSetting) {
    CardVersionSetting["TWO_CARD"] = "TWO_CARD";
    CardVersionSetting["THREE_CARD"] = "THREE_CARD";
    CardVersionSetting["FIVE_CARD"] = "FIVE_CARD";
    CardVersionSetting["SEVEN_CARD"] = "SEVEN_CARD";
    CardVersionSetting["NINE_CARD"] = "NINE_CARD";
    CardVersionSetting["EQUAL_TO_PLAYERS"] = "EQUAL_TO_PLAYERS";
})(CardVersionSetting || (exports.CardVersionSetting = CardVersionSetting = {}));
//# sourceMappingURL=CardVersionSetting.js.map